import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { canAccessSlug, landingFor } from '../config/access.js';

/**
 * Capability guard: deny-by-default enforcement of the business-capability
 * access model (config/access.js) on the routes it wraps. Complements
 * RoleRoute — that checks the coarse platform role; this checks that the
 * signed-in user's `title` actually grants the workspace, so e.g. a Finance
 * User can't URL-navigate into User Administration.
 *
 * Derives the slug from the current location's first path segment (alias
 * paths resolve via the access map) and, on denial, sends the user to their
 * own home workspace instead of a blank screen. Nest inside RoleRoute so
 * authentication/loading are already settled:
 *
 *   <Route element={<RoleRoute roles={['admin']} />}>
 *     <Route element={<CapabilityRoute />}>
 *       <Route element={<AdminLayout />}>...</Route>
 *     </Route>
 *   </Route>
 */
export default function CapabilityRoute() {
  const { user } = useAuth();
  const location = useLocation();
  const slug = location.pathname.replace(/^\//, '').split('/')[0];

  if (!canAccessSlug(user, slug)) {
    return <Navigate to={landingFor(user)} replace />;
  }

  return <Outlet />;
}
